import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class AuthenticatedPslfFormReasonSubmittingController extends Controller {
  @tracked signerType = '';
  queryParams = ['signerType'];
}
